var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "use_rule" } }, [
    _c("div", { attrs: { id: "use_rule_scroll" } }, [
      _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm._m(4),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm._m(6),
        _vm._v(" "),
        _vm._m(7),
        _vm._v(" "),
        _vm._m(8),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        !_vm.isConstruct
          ? _c("section", [
              _c("div", [_vm._v("第１１条（設置サービス）")]),
              _vm._v(" "),
              _vm._m(10)
            ])
          : _c("section", [
              _c("div", [_vm._v("第１１条（業務サービス）")]),
              _vm._v(" "),
              _vm._m(11)
            ]),
        _vm._v(" "),
        _vm._m(12),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _vm._m(14),
        _vm._v(" "),
        _vm._m(15),
        _vm._v(" "),
        _vm._m(16),
        _vm._v(" "),
        _vm._m(17),
        _vm._v(" "),
        _vm._m(18),
        _vm._v(" "),
        _vm._m(19),
        _vm._v(" "),
        _vm._m(20),
        _vm._v(" "),
        _vm._m(21)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１条（利用者）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "HAKOTAN利用者（以下「利用者」という。）とは、株式会社ヤスモク（以下「当社」といいます。）が開発、運営及び提供するサービス「HAKOTAN」（以下「本サービス」という。）を利用する法人又は個人をいいます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "HAKOTAN会員（以下「本会員」という。）とは、利用者のうち、本サービスの継続的な利用を目的として、当社所定の方法で会員登録を申し込み、当社が会員として登録を認めたものをいいます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "一時利用者とは、利用者のうち、会員登録をせずに本サービスを利用する会員以外の全てのものをいいます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、本利用規約を遵守することに同意した上で、本利用規約に基づき、本サービスを利用することができます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "本会員は、その会員資格を第三者に利用させ、又は貸与、譲渡、担保供与その他の処分をすることはできません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "本サービスに関する知的財産権その他の一切の権利は、当社又は当社の指定する第三者に帰属し、利用者には帰属しません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、本サービスの内容を当社に無断で転載、複製、修正、蓄積又は転送してはなりません。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第２条（利用規約の変更）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [_vm._v("当社は、本利用規約を変更できるものとします。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社が本利用規約を変更した場合には、本会員に当該変更内容を通知するものとし、当該変更内容の通知後、本会員が本サービスを利用した場合、又は当社の定める期間内に退会手続をとらなかった場合には、本会員は、本規約の変更に同意したものとみなします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "前２項にかかわらず、一時利用者については、当社が本利用規約を変更した場合でも、一時利用者が同意した時点の本利用契約が引き続き適用されるものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第３条（当社の地位）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "当社は、本サービスを運営及び提供するものであり、本サービスを通じて利用者と出品メーカーが締結する商品の売買契約（以下「売買契約」という。）の当事者にはなりません。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本サービスにおいて出品メーカーが出品した商品に関する一切の事項について何らの責任を負いません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本利用規約に定めがある場合を除き、本サービスに関して利用者間、利用者と出品メーカーとの間、又は利用者、出品メーカーとその他の第三者との間で発生した一切のトラブルについて責任を負いません。これらのトラブルが発生した場合には、当事者間で解決するものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第４条（会員登録）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本サービスの会員登録希望者（以下「会員登録希望者」という。）は、当社所定の会員情報の登録（以下「会員登録」という。）をすることにより、当社に対し、会員登録の申請をすることができます。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("会員登録及び会員の会員費は、無料とします。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "会員登録は、会員登録希望者本人が正確な情報を入力するものとします。当社は、誤った情報を入力したことによる損害について一切の責任を負いません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("利用者は、複数の会員登録を行うことはできません。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、利用希望者が次の各号のいずれかに該当する場合、会員登録の申請を承認しない場合があります。この場合、当社は、審査結果の詳細を開示する義務を負わないものとし、また、会員登録希望者は、その結果に対し異議申し立てはできないものとします。\n            "
          ),
          _c("ul", [
            _c("li", [
              _vm._v(
                " (1) 過去に本利用規約その他の当社が定める規約に違反したことがある者である場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (2) 会員登録の内容に正確ではない情報、又は虚偽の情報が含まれている場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (3) 本サービスの提供若しくは他の利用者の利用を妨害する行為を行った場合、又はそのおそれがあると当社が判断した場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" (4) 本会員が重複して会員登録申請を行った場合")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (5) 当社に対する金銭債務の支払を怠ったことがある場合")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (6) 暴力団員、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団構成員その他これに準じる反社会的勢力の構成員（以下「反社会的勢力等」という。）であると判明した場合又は反社会的勢力等が経営に実質的に関与している法人の役員、従業員である等反社会的勢力等と何らかの関係を有していると判明した場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" (7) その他当社が不適当であると判断する場合")])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、会員登録を承認しないことにより生じた不利益及び損害について、一切の責任を負いません。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第５条（本会員登録の変更）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本会員は、会員登録の内容に変更がある場合、直ちにこれを変更しなければならず、常に本会員自身の正確な情報が登録されるよう、登録内容を管理及び修正する責任を負うものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "会員登録の内容に変更があったにも関わらず、変更を行っていない場合、当社は、登録内容の変更のないものとして取り扱うことができます。変更の届出があった場合でも、変更登録前に行われた取引や各種手続は、変更前の情報に依拠する場合があります。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "会員登録の内容を変更しないことによる不利益について、当社は一切の責任を負いません。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第６条（ユーザーＩＤ及びパスワードの管理）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本会員は、ユーザーＩＤ及びパスワードを自己の責任において適切に管理するものとし、これを第三者に利用させ、又は譲渡、貸与、質入、名義変更その他の処分をしてはならないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "ユーザーＩＤ及びパスワードの管理不十分による情報の漏洩、使用上の過誤、第三者の使用、不正アクセス等による損害の責任は本会員が負うものとし、当社は一切責任を負わないものとします。ユーザーＩＤ又はパスワードが不正に利用されたこと等により、当社に損害が生じた場合、本会員は当該損害を賠償するものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "ユーザーＩＤ及びパスワードの情報が第三者に漏洩した場合又はそのおそれがある場合、本会員は、速やかに当社に報告するとともに、当社の指示がある場合にはこれに従うものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第７条（退会）")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "本会員は、当社所定の退会手続きを行うことにより、いつでも退会することができるものとします。ただし、退会によりその時点で成立している売買契約を解除することはできません。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第８条（会員資格の取消）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "当社は、本会員が次の各号のいずれかに該当すると当社が判断した場合、事前の通知なしに、会員資格を取消すことができるものとします。当社は、その理由を説明する義務を負わないものとします。\n            "
          ),
          _c("ul", [
            _c("li", [_vm._v(" (1) 法令又は本利用規約に違反した場合")]),
            _vm._v(" "),
            _c("li", [_vm._v(" (2) 不正行為があった場合")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (3) 会員登録の情報が虚偽であると当社が判断した場合")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (4) 本利用規約に必要となる手続又は当社への報告を行わなかった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (5) 会員登録の情報が既存の登録情報と重複している場合")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (6) 登録した電話番号又はメールアドレスが不通になったことが判明した場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (7) 債務超過、無資力、支払停止又は支払不能の状態に陥った場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (8) 破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始もしくはその他適用ある倒産手続開始の申立が行われた場合又は解散もしくは営業停止状態である場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (9) 過去に本規約等に違反し本サービスの利用停止処分となった者である場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (10) 他の会員、出品メーカーその他第三者に不当に迷惑をかけた場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (11) 自ら又は第三者をして、暴力的な要求行為、法的な責任を超えた不当な要求行為、脅迫的な言動又は暴力を用いる行為、風評を流布し、偽計を用い又は威力を用いて、信用を毀損又は業務を妨害する行為をした場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (12) その他当社が本会員に相応しくないと判断した場合")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本条の措置を受けた者に対し、将来にわたって当社が提供するサービスの利用を禁止することができるものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本条の措置により生じる不利益及び損害について、一切の責任を負わないものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第９条（売買契約の成立）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "利用者は、本サービス上の所定の手続きにより、商品購入の申し込みを行うことができます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、購入する意思のない商品購入の申込み等を行うことはできません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "第１項の商品購入申し込みに対して、当社所定の方法で出品メーカーがそれを同意した時をもって売買契約が成立するものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、売買契約の成立後、その売買契約を取り消すことはできません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "前項にかかわらず、利用者が第１１条に定める組立設置サービスの利用を希望する場合で組立設置サービス会社との間で組立設置サービス契約が成立しなかったときは、売買契約を取り消すことができます。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "商品に瑕疵がある場合、商品説明と実際の商品が明らかに異なる場合、梱包の不備により配送時に商品が破損した場合その他の商品の不具合については、納入後１か月間に限り、出品メーカーの責任及び費用により、返金、修理又は交換等の対応を行うものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１０条（支払い）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "売買契約が成立した場合、利用者は、当社所定の手続に従って商品代金を支払うものとします。また、支払いに必要な振込手数料その他の費用についての利用者の負担は、当社所定の手続で定められるところに従うものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社又は当社の指定する会社は、出品メーカー、またはその他のサービスを提供する企業からの委託により商品・サービス代金の代理受領権限を付与されており、当該代理受領の時点をもって決済が完了するものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "商品の発送は、商品代金の決済完了後、出品メーカーより直接発送されるものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "決済方法として掛け払いを適応する場合、メーカーによる商品の納品、または委託企業による納品に付随するサービスの提供完了30日間後の月末に締め、翌月５営業日以内に当社より請求書を発行、翌々月末日までに支払いを行うこととします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "利用者は、所定の手続きにより、商品を組み立てて利用者が別途指定する場所に設置する「組立設置サービス」（以下「組立設置サービス」といいます。）の申し込みをすることができます。 "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "組立設置サービスは、当社が指定する組立設置サービス会社（以下「組立設置サービス会社」といいます。）が行います。"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "当社は組立設置サービスに関する契約（以下「組立設置サービス契約」といいます。）の契約当事者にはなりません。利用者は、組立設置サービス会社との間で組立設置サービス契約を別途締結するものとし、組立設置サービス契約の契約当事者は、利用者と組立設置サービス会社になります。なお、利用者は、組立設置サービス契約が以下の条件となっていることについてあらかじめ承諾したうえで組立設置サービス契約を締結するものとします。"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            " (1) 利用者は、民法第641条（注文者による契約の解除）及び同法第651条（委任の解除）の定めにかかわらず、組立設置サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできないこと。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " (2) 利用者は、組立設置サービス契約の締結後に当該契約の履行が不要になった場合でも、利用者は当該契約の代金を当該契約の支払条件に従って支払わなければならないこと。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "第１項の組立設置サービスの申し込み後、当社所定の方法で組立設置サービス会社が当該申し込みに対する承諾をしたときに、当社と利用者との間で「組立設置サービス代金の収納代行に関する契約」が成立するものとします。ただし、利用者と組立設置サービス会社との間で組立設置サービス契約が成立しなかったとき、又は、組立設置サービス契約が取り消されたときは、当社と利用者との間の当該「組立設置サービス代金の収納代行に関する契約」も自動的に取り消されるものとします。"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "組立設置サービス会社による組立設置サービスの履行が組立設置サービス契約の内容に適合しないとき、又は、組立設置サービス会社が組立設置サービスの履行に際して組立設置サービス会社の帰責事由により購入した商品を棄損したときは、利用者と組立設置サービス会社との間で別途締結する組立設置サービス契約の条件に基づいて、利用者と組立設置サービス会社との間で解決するものとします。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "本会員は、所定の手続きにより、以下のサービス（以下「業務サービス」といいます。）の申し込みをすることができます。 "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            " (1) 本会員が別途指定する場所に商品が設置可能かを事前に調査する「現場調査サービス」"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " (2) 商品を受け取り、設置日に本会員が別途指定する場所に搬入する「受取搬入サービス」"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " (3) 商品を組み立てて本会員が別途指定する場所に設置する「組立設置サービス」"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "業務サービスは、当社が指定する業務サービス会社（以下「業務サービス会社」といいます。）が行います。 "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "当社は業務サービスに関する契約（以下「業務サービス契約」といいます。）の契約当事者にはなりません。本会員は、業務サービス会社との間で業務サービス契約を別途締結するものとし、業務サービス契約の契約当事者は、本会員と業務サービス会社になります。なお、本会員は、業務サービス契約が以下の条件となっていることについてあらかじめ承諾したうえで業務サービス契約を締結するものとします。（１）本会員は、民法第 641条（注文者による契約の解除） "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            " (1) 本会員は、民法第 641条（注文者による契約の解除）及び同法第 651条（委任の解除）の定めにかかわらず、業務サービス契約の締結後は当該契約の解除（キャンセル）及び代金の返金はできないこと。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " (2) 本会員は、業務サービス契約の締結後に当該契約の履行が不要になった場合でも、本会員は当該契約の代金を当該契約の支払条件に従って支払わなければならないこと。"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "第１項の業務サービスの申し込み後、当社所定の方法で業務サービス会社が当該申し込みに対する承諾をしたときに、当社と本会員との間で「業務サービス代金の収納代行に関する契約」が成立するものとします。ただし、本会員と業務サービス会社との間で業務サービス契約が成立しなかったとき、又は、業務サービス契約が取り消されたときは、当社と本会員との間の当該「業務サービス代金の収納代行に関する契約」も自動的に取り消されるものとします。"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "業務サービス会社による業務サービスの履行が業務サービス契約の内容に適合しないとき、又は、業務サービス会社が業務サービスの履行に際して業務サービス会社の帰責事由により購入した商品を棄損したときは、本会員と業務サービス会社との間で別途締結する業務サービス契約の条件に基づいて、本会員と業務サービス会社との間で解決するものとします。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１２条（本サービスの中断等）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "当社は、次の各号のいずれかに該当する場合には、利用者に事前に通知することなく一時的に本サービスの全部又は一部を中断することができるものとします。その際、利用者に損害が発生した場合であっても、当社は一切の責任を負わないものとします。\n            "
          ),
          _c("ul", [
            _c("li", [
              _vm._v(
                " (1) サーバー、通信回線、その他の設備の故障、障害の発生又はその他の理由により本サービスの提供ができなくなった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (2) システム（サーバー、通信回線や電源、それらを収容する建築物などを含む）の保守、点検、修理、変更を定期的に又は緊急に行う場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (3) 火災、停電等により本サービスの提供ができなくなった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (4) 地震、噴火、洪水、津波等の天災により本サービスの提供ができなくなった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (5) 戦争、変乱、暴動、騒乱、労働争議等その他不可抗力により本サービスの提供ができなくなった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (6) 法令又はこれに基づく措置により本サービスの提供ができなくなった場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (7) その他、運用上又は技術上当社が本サービスの一時的な中断を必要と判断した場合"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、任意の理由により、利用者への事前通知をすることなく、いつでも本サービスの全部又は一部を終了及び変更できるものとします。当社は、本サービスの終了及び変更による損害について、利用者及び第三者に対して一切責任を負わないものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１３条（知的財産権等）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本サービスを構成するシステム、プログラム、ソースコード、コンテンツ、データベースその他本サービスに関連又は付随するデータ、文書、情報等にかかる特許権、著作権、商標権、ノウハウその他の知的財産権を含む一切の権利（以下「知的財産権等」といいます。）は、当社に帰属します。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、本サービスの利用に関して、本規約に定めるほか何らの知的財産権等を取得することはないものとし、本サービスの知的財産権等を侵害してはならないものとします。本規約に基づく本サービスの利用の許諾は、本サービスに関する弊社の権利の使用許諾を意味するものではありません。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者が本サービスに関連して発信又は掲載したコンテンツに関する一切の責任は、当該利用者が負うものとし、当社は、その内容、品質、正確性、信憑性、適法性、最新性、有用性等について、一切確認及び保証せず、一切責任を負わないものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、他の利用者が発信又は掲載するコンテンツに対して、その内容、品質、正確性、信憑性、適法性、最新性、有用性等を、利用者ご自身で判断する必要があります。当社は、利用者及び第三者が当社のコンテンツを利用することにより生じる損害について、一切責任を負わないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社はコンテンツのバックアップを行う義務を負わないものとします。利用者は、コンテンツのバックアップが必要な場合には、自己の費用と責任でこれを行うものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、利用者が本規約等に違反又は本規約等の趣旨に照らして不適切な行為を行ったと当社が判断した場合、当該利用者が掲載したあらゆるコンテンツを、事前の通知なしに変更及び削除できるものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１４条（個人情報等の取扱い）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "当社は、本規約のほか、個人情報保護法に従い利用者の個人情報等を取り扱うものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、当社が利用者から取得する個人情報等に関して、次の各号に定める目的で利用することができるものとし、利用者はこれに同意します。\n            "
          ),
          _c("ul", [
            _c("li", [_vm._v(" (1) 本サービスを提供するため ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (2) 本サービスに関する登録の受付や本人確認等、本サービスを提供、維持、改善するため "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (3) 本サービスに関するご案内、問い合わせ等への対応のため"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" (4) 本利用規約に違反する行為に対応するため")]),
            _vm._v(" "),
            _c("li", [_vm._v(" (5) 本利用規約等の変更などを通知するため")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (6) 本サービスおよび当社（当社関連会社を含む。以下同じ。）が提供するサービスの改善に利用するため"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (7) 当社製品の広告宣伝またはマーケティングのため")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (8) その他各号の利用目的に付随する利用目的のため")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、法令に基づく場合又は以下の各号に定める場合を除き、個人情報等を第三者に預託又は提供する場合は、事前に利用者の同意を得ることなしにこれを行いません。\n            "
          ),
          _c("ul", [
            _c("li", [
              _vm._v(
                " (1) 前項の利用目的の達成に必要な範囲において個人情報の取扱いの全部または一部を委託する場合 "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (2) 前項の利用目的の達成に必要な範囲で、当社のグループ会社及び当社が業務等を委託する第三者に対し、個人情報を提供する場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (3) 合併その他の事由による事業の承継に伴って個人情報を提供する場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (4) 国の機関もしくは地方公共団体またはその委託を受けたものが、法令の定める事務を遂行することに対して協力する必要がある場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" (5) 個人情報保護法その他の法令で認められる場合")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (6) 利用者又は第三者からの照会があり、かつ、利用者又は第三者の正当な権利行使のために、当社が開示を必要と判断した場合"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" (7) その他プライバシーポリシーに定める場合 ")])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "個人情報等を前項に基づき第三者に預託又は提供したことによる利用者の損害について、当社は一切責任を負わないものとします。利用者は、本条の内容を十分に認識した上で、本サービスを利用するものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、利用者が本サービスに入力した個人情報等について、関連法規に従い、事実確認を行った上で、訂正、削除又は利用停止等の適切な措置を講じるものとし、この場合、利用者は当該措置に異議申立てを行えないものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１５条（インターネット接続環境）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本サービスの提供を受けるために必要なコンピューター、スマートフォンその他の機器、ソフトウェア、通信回線その他の通信環境等は、利用者の費用と責任において準備し維持するものとします。当社は、本サービスがあらゆる機器等に適合することを保証するものではなく、機器等の準備、設置、操作に関し、一切関与せず、利用者に対するサポートも行いません。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者がインターネット回線を通じて行う本サービスへの入力、購入、退会その他の手続は、当社のサーバーに当該手続に関するデータが送信され、当社のシステムに当該手続の内容が反映された時点をもって有効に成立するものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１６条（禁止事項等）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "利用者は、本サービスを利用するにあたり、次の各号の行為をし、又はしようとしてはならないものとします。\n            "
          ),
          _c("ul", [
            _c("li", [_vm._v(" (1) 本利用規則又は法令に違反する行為 ")]),
            _vm._v(" "),
            _c("li", [_vm._v(" (2) 本サービスへの不正アクセス行為 ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (3) 本サービスの破壊行為（過度な負担、ウィルス等による破壊を含む。）"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (4) 本サービスの複製、解析、改変、頒布、公衆送信、送信可能化その他の弊社の知的財産権等を侵害する行為 "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " (5) 本サービスのソースコード等に対して逆アセンブル、逆コンパイル及びリバースエンジニアリング等を行う行為"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" (6) その他当社が不適切と判断する行為 ")])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者が前項の禁止行為を行ったと当社が判断した場合、当社は、当該利用者に対する事前の通知なしに、当該利用者が掲示、発信した情報の削除、当該利用者による本サービスの全部又は一部の利用停止、商品の代金等の支払留保、その他当社が必要と判断する措置を講じることができるものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "前項の措置を講じたことによる利用者の損害又は不利益について、当社は一切の責任を負わないものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者が第１項の禁止行為を行ったことにより当社に損害を与えた場合には、当社に対してその一切の損害を賠償するものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１７条（免責事項）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "当社は、本利用規約に定めるもののほか、本サービスに関連して利用者間又は利用者と第三者間で発生した一切のトラブルについて、一切の責任を負わず、また一切関与しません。トラブルが生じた際には、当事者間で解決するものとし、当該トラブルにより当社が損害を被った場合は、当事者は連帯して当該損害を賠償するものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者間又は利用者と第三者との間で、本サービスに関連して、裁判やクレーム、請求等あらゆるトラブルを含む紛争が生じた場合、各自の責任や費用で解決するものとし、当社は、当該紛争に関し、一切関与しません。利用者は、当該紛争の対応のために当社に生じた損害を連帯して負担することに同意するものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、当社との間で紛争が生じた場合、当該紛争に関連して当社に発生した弁護士費用を含むあらゆる費用を負担することに同意するものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本サービスの内容・品質・水準、サービスの安定的な提供、本サービスの利用に伴う結果等については、一切保証しません。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "本サービス提供における、不正確、不適切又は不明瞭な内容、表現又は行為等により、利用者及び第三者に対して損害が生じた場合であっても、直接的か間接的かを問わず、当社は、その損害について一切責任を負わないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、当社が利用者に対して行う情報提供の正確性及び有用性については保証しません。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていないことについては、一切保証しません。当社は、本サービスに関連するコンテンツの中に、コンピュータウィルス等有害なものが含まれていたことにより生じた損害について、直接的か間接的かを問わず、利用者及び第三者に対して一切責任を負わないものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、利用者が利用した機器・通信回線・ソフトウェア等により利用者又は第三者に生じた損害について、直接的か間接的かを問わず、一切責任を負わないものとします。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、本サービスへのアクセス不能、利用者のコンピューターにおける障害、エラー、バグの発生等について、一切責任を負わないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、コンピューター、システム、通信回線等の障害により、利用者及び第三者が被った一切の損害（データ消失、システムの中断、不正アクセス等）について、直接的か間接的かを問わず、一切責任を負わないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社は、利用者が書き込んだ他のウェブサイト又はアプリケーション等へのURL等を使用した誘導その他本サービス以外における利用者の購入により生じた損害について、直接的か間接的かを問わず、一切責任を負わないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "利用者は、本サービスに起因して利用者に生じた一切の損害（間接損害、派生損害、逸失利益、特別の事情から生じた損害（損害発生につき弊社の予見の有無を問いません。）を含みます。）について、当社を免責するものとし、金銭賠償その他の請求を行わないことに同意するものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１８条（守秘義務）")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "利用者は、本サービスの利用にあたり覚知した当社及び出品メーカーの一切の情報（公知のものを除く。）を秘密に保持し、これを第三者に開示してはならないものとします。 "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第１９条（地位の譲渡等）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "利用者は、本利用規約に基づく権利、義務及び本規約等の契約上の地位の全部又は一部について、これを第三者に譲渡、移転、担保設定、貸与、その他の方法により処分してはならないものとします。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社が本サービスに係る事業を第三者に譲渡する場合（事業譲渡、会社分割その他本サービスが移転する一切の場合を含みます。）には、当該事業の譲渡に伴い、利用者の本利用規約等に基づく契約上の地位、権利義務及び会員登録に伴い登録された情報その他の情報を、当社は当該事業の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき予め承諾するものとします。"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第２０条（反社会的勢力の排除）")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当社は、反社会的勢力等による本サービスの利用を禁止します。当社は、利用者が反社会的勢力等に該当すると判断した場合、事前に通知することなく、本サービスの提供を停止することができます。当社は、これによって利用者に生じた損害や不利益について、一切の責任を負いません。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("第２１条（準拠法・管轄裁判所）")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _vm._v(
            "本利用規約は、日本法に基づき解釈されるものとします。なお、本サービスにおいて物品の売買が発生する場合であっても、国際物品売買契約に関する国際連合条約（CISG）の適用を排除することに合意します。 "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "当社と利用者との間で生じた紛争については、訴額に応じて東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。 "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5886554", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5886554","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/common/DcUseRuleDetial.vue
// module id = null
// module chunks = 